import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessGoalsGoalDescriptionRoute extends Route {
  model() {
    return this.modelFor('business.goals.goal');
  }
}

export default instrumentRoutePerformance(BusinessGoalsGoalDescriptionRoute);
